import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMonitor = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-monitor",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 14,
			x: 2,
			y: 3,
			rx: 2
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 8,
			x2: 16,
			y1: 21,
			y2: 21
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 12,
			x2: 12,
			y1: 17,
			y2: 21
		})
	]
});
export { SvgMonitor as ReactComponent };
